module.exports = __webpack_public_path__ + "static/media/GnomeSpeech.1d4da4fe.svg";